import { render, staticRenderFns } from "./ReorderFaqs.vue?vue&type=template&id=1e2816f6&scoped=true"
import script from "./ReorderFaqs.vue?vue&type=script&lang=js"
export * from "./ReorderFaqs.vue?vue&type=script&lang=js"
import style0 from "./ReorderFaqs.vue?vue&type=style&index=0&id=1e2816f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2816f6",
  null
  
)

export default component.exports